import { Menubar } from 'primereact/menubar';
import { useLocation } from 'react-router-dom';

function NavBar() {
    const location = useLocation();
    const regex = /^\/magazine\/[a-f0-9-]+\/publication\/[a-f0-9-]+\/fullscreen$/;
    const isFullScreen = regex.test(location.pathname);
    return (
        !isFullScreen && 
        <div>
            <Menubar start={
                <a href="/" style={{textDecoration: 'none', color: 'white', fontSize: '1.2em'}}>Magazine Viewer</a>
            } />
        </div>
    )
};

export default NavBar;